import {
    createContext,
    Dispatch,
    FC,
    SetStateAction,
    useContext,
    useState,
    useMemo,
    ReactNode,
} from "react";
import { ErrorType } from "layouts/relaunch/pages/ErrorLayout";

export interface ContextProps {
    setErrorType: Dispatch<SetStateAction<ErrorType | undefined>>;

    errorType?: ErrorType;
}

export const initialContext = {
    setErrorType: () => {},
};

export const ErrorContext = createContext<ContextProps>(initialContext);

export const useErrorContext = () => useContext(ErrorContext);

export const ErrorContextProvider: FC<{
    children: (errorType: ErrorType | undefined) => ReactNode;
}> = ({ children }) => {
    const [errorType, setErrorType] = useState<ErrorType | undefined>();

    const memoizedValue = useMemo(() => {
        return { errorType, setErrorType };
    }, [errorType]);

    return (
        <ErrorContext.Provider value={memoizedValue}>
            {children(errorType)}
        </ErrorContext.Provider>
    );
};
